import * as styles from './EpostValidationErrorsTable.module.css'

export const EpostValidationErrorsCell = {
  Code: 'code',
  Count: 'count',
  Recipient: 'recipient',
  Text: 'text',
}

export const EPOST_VALIDATION_ERRORS_HEADER_COLUMNS = [
  {
    className: styles.cell,
    index: 0,
    name: EpostValidationErrorsCell.Text,
    ordering_field: null,
    title: 'Epost.ValidationErrorsErrorTypeTitleKey',
    visible: true,
  },
  {
    className: styles.cell,
    index: 1,
    name: EpostValidationErrorsCell.Recipient,
    ordering_field: null,
    title: 'Epost.ValidationErrorsRecipientTitleKey',
    visible: true,
  },
]
